import { Outlet, useParams } from "react-router";
import { createContext, useContext, useEffect, useState } from "react";
// import { IDisributorInfoExtend, IPartnerExtend } from "./DistributorDetail";
import { apiRemote } from "@/api/wp-api";
import { useAlert } from "@/contexts/AlertContext";
import { decodeId } from "@/utils/decodeId";
import { useCustomBreadcrumb } from "@/contexts/CustomBreadcrumb";
import { IDashboardMetricsExtend } from "./Dashboard-Metrics";
import { ICurrentRankLeaderBoardExtend } from "./LeaderboardRank";
import { IDashboardUserBadgeExtend } from "./Badge-Section";
import { IDashboardUserCourseExtend } from "./My-Course";
import { IDashboardIndonesiaCompetitonCoursesExtend } from "./IndonesiaCompetitonCourses";
import { IDashboardCheckPaymentStatusApiExtend } from "./IndonesiaCompetitonCourses";
import { ILeaderBoardExtend } from "./LeaderboardDialog";
import { IDashboardUserContestExtend } from "./My-Contest";
import { IDashboardOrtherCourseContestExtend } from "./OrtherCourseContest";
import { IDashboard } from "@/api";



// Define the context interface
export interface DashboardContextType {
    currentRankLeaderBoard: ICurrentRankLeaderBoardExtend;
    dashboarMetrics: IDashboardMetricsExtend;
    getDashBoard: () => Promise<any>;
    getDashboardUserBadge: (page: any, pageSize: any) => Promise<any>;
    getDashboardUserCourse: (page: any, pageSize: any) => Promise<any>;
    getDashboardIndonesiaCompetitonCourses: (page: any, pageSize: any) => Promise<any>;
    checkPaymentStatusApi: (courseid: any) => Promise<any>;
    getDashboardUserContest: (page: any, pageSize: any) => Promise<any>;
    getDashboardMetrics: () => Promise<any>;
    getDashboardOrtherCourseContest: () => Promise<any>;
    getDataLeaderBoard: () => Promise<any>;
}
const DashboardContext=createContext<DashboardContextType>({} as any);

export function DashboardLayout(){
    const { id } = useParams<{ id: string }>(); 
    const alert=useAlert();
    
    const [dashboardMetricData, setDashboardMetricData] = useState<IDashboardMetricsExtend>({}as any);
    const [currentRankLeaderBoardData, setCurrentRankLeaderBoardData] = useState<ICurrentRankLeaderBoardExtend>({}as any);
    const [dashboardMetricsData, setDashboardMetricsData] = useState<IDashboardMetricsExtend>({}as any);
    const [leaderBoardData, setLeaderBoardData] = useState<ILeaderBoardExtend>({}as any);
    const customBreadcrumb=useCustomBreadcrumb();

    const loadDataDashboardMetrics=()=>{
        return apiRemote.getDashboardMetrics().catch((err: any) => {
            alert.error(err.message);
            return {} as IDashboardMetricsExtend; // Trả về giá trị mặc định khi có lỗi
        });
    }

    const getDashBoard=()=>{
        return apiRemote.getDashboard().catch((err: any) => {
            alert.error(err.message);
            return {} as IDashboard; // Trả về giá trị mặc định khi có lỗi
        });
    }

    const getDataLeaderBoard=()=>{
        return apiRemote.getDataLeaderBoard().catch((err: any) => {
            alert.error(err.message);
            return {} as ILeaderBoardExtend; // Trả về giá trị mặc định khi có lỗi
        });
    }

    const getDashboardUserBadge=(page: any, pageSize: any)=>{
        return apiRemote.getDashboardUserBadge(page, pageSize).catch((err: any) => {
            alert.error(err.message);
            return {} as IDashboardUserBadgeExtend; // Trả về giá trị mặc định khi có lỗi
        });
    }

    const getDashboardUserCourse=(page: any, pageSize: any)=>{
        return apiRemote.getDashboardUserCourse(page, pageSize).catch((err: any) => {
            alert.error(err.message);
            return {} as IDashboardUserCourseExtend; // Trả về giá trị mặc định khi có lỗi
        });
    }

    const getDashboardIndonesiaCompetitonCourses=(page: any, pageSize: any)=>{
        return apiRemote.getDashboardIndonesiaCompetitonCourses(page, pageSize).catch((err: any) => {
            alert.error(err.message);
            return {} as IDashboardIndonesiaCompetitonCoursesExtend; // Trả về giá trị mặc định khi có lỗi
        });
    }

    const checkPaymentStatusApi=(course_id: any)=>{
        return apiRemote.checkPaymentStatusApi(course_id).catch((err: any) => {
            alert.error(err.message);
            return {} as IDashboardCheckPaymentStatusApiExtend; // Trả về giá trị mặc định khi có lỗi
        });
    }

    const getDashboardUserContest=(page: any, pageSize: any)=>{
        return apiRemote.getDashboardUserContest(page, pageSize).catch((err: any) => {
            alert.error(err.message);
            return {} as IDashboardUserContestExtend; // Trả về giá trị mặc định khi có lỗi
        });
    }

    const getDashboardOrtherCourseContest=()=>{
        return apiRemote.getDashboardOrtherCourseContest().catch((err: any) => {
            alert.error(err.message);
            return {} as IDashboardOrtherCourseContestExtend; // Trả về giá trị mặc định khi có lỗi
        });
    }

    useEffect(()=>{
        // alert.showWait();
        // console.log(`from layout ${id}`);

        // var dashboard = getDashBoard();

        // // var dataLeaderBoard = getDataLeaderBoard();
        

        // Promise.all([dashboard]).then(([resDashboard])=>{
        //     if (resDashboard) {
        //         setCurrentRankLeaderBoardData(resDashboard.currentRankLeaderboard);
        //         setDashboardMetricsData(resDashboard.infomationUser)
        //     }
        // }).catch((err)=>{
        //     alert.error(err.message);
        // }).finally(()=>{
        //     alert.hideWait();
        // });



    },[id]);
    return (
        <DashboardContext.Provider value={{currentRankLeaderBoard: currentRankLeaderBoardData, dashboarMetrics: dashboardMetricsData, getDashboardUserBadge, getDashboardUserCourse, getDashboardIndonesiaCompetitonCourses, checkPaymentStatusApi, getDashboardUserContest, getDashboardMetrics: loadDataDashboardMetrics, getDashboardOrtherCourseContest, getDataLeaderBoard, getDashBoard}}>
            <Outlet />
        </DashboardContext.Provider>
    )
}

export function useDashboardContext(){
    return useContext(DashboardContext);
}